import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { OndeAtuaSection } from 'volto-ministerio-publico-federal/components/View/CapaView/OndeAtuaSection';
import {
  temaHasContent,
  toOndeAtuaTemas,
  type OndeAtuaData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface MpfOndeAtuaBlockViewProps {
  data: OndeAtuaData;
  /** Presente só no editor: `(slot do tema, índice do card)`. */
  onEditItem?: (tema: number, index: number) => void;
}

const EMPTY_TEXT =
  'Sem temas cadastrados. Preencha ao menos um tema para a faixa aparecer na capa.';

/** Bloco "Onde o MPF atua? (capa)". */
const MpfOndeAtuaBlockView = ({
  data,
  onEditItem,
}: MpfOndeAtuaBlockViewProps) => {
  const isEmpty = !toOndeAtuaTemas(data).some(temaHasContent);

  if (isEmpty) {
    return (
      <section className="rounded-md border border-dashed border-gray-300 p-4 dark:border-night-850">
        <h2 className="text-lg font-semibold text-on-surface dark:text-night-100">
          Onde o MPF atua?
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-night-400">
          {data?.placeholder || EMPTY_TEXT}
        </p>
      </section>
    );
  }

  /* `isEditMode={!!onEditItem}`, e não cravado em `true`: só o `Edit.tsx` passa
     `onEditItem`. Cravado, a página PUBLICADA herdava o comportamento de
     edição — slots vazios apareciam e os cards deixavam de ser links (ver os
     usos de `isEditMode` em `View/CapaView`). */
  return (
    <OndeAtuaSection
      data={data}
      isEditMode={!!onEditItem}
      onEditItem={onEditItem}
    />
  );
};

export default withBlockExtensions(MpfOndeAtuaBlockView);
